import React, { useEffect, useState } from 'react';
import CreditBundleOrderModal from 'components/billing/CreditBundleOrderModal';
import { useAuthContext } from 'services/authentication/AuthenticationContext';
import { fetchData } from 'services/api/fetchData';
import { DayPassBundle, DayPassOverview } from './SubcontractorTypes';

interface DayPassOrderModalProps {
    bundles?: DayPassBundle[];
    onOrderCompleted?: () => void;
}

// The day pass bundle order modal, the shared bundle modal with the day pass endpoints
const DayPassOrderModal: React.FC<DayPassOrderModalProps> = ({ bundles, onOrderCompleted }) => {
    const { handleLogout } = useAuthContext();
    const [bundleOptions, setBundleOptions] = useState<DayPassBundle[]>(bundles || []);

    // Fetch the bundles when they are not given by the caller
    useEffect(() => {
        if (bundles && bundles.length > 0) return;
        const fetchBundles = async () => {
            const overview: DayPassOverview = await fetchData({ apiUrl: 'get_subcontractor_day_pass_overview', handleLogout });
            setBundleOptions(overview?.bundles || []);
        };
        fetchBundles();
    }, []);

    return (
        <CreditBundleOrderModal
            bundles={bundleOptions}
            orderApiUrl='post_day_pass_order'
            returnPath='/settings/general/subcontractors/thank-you'
            translationPrefix='subcontractor.day_pass'
            onOrderCompleted={onOrderCompleted}
        />
    );
};

export default DayPassOrderModal;
